/* eslint-disable multiline-ternary */
import { trans } from 'sharedKernel/i18n'
import React, { createContext, useEffect, useState } from 'react'
import { Prompt, useSearchParams } from 'react-router-dom'
import { fullResetEvent, store, TReducers, useSelector } from 'store'
import { Loading } from 'components/loading'
import { validateAll } from 'domain/feature/hub/company/challenge/FormWrapper/behaviors/validation'
import { fillEvent } from '../formBuilder/fillForm'
import { resetEventFiles } from 'domain/feature/hub/company/events/FormWrapper/file/store/actions'
import { FormWrapper } from 'domain/feature/hub/company/events/FormWrapper'

export const InitialFormContext = createContext('')

export const HubCompanyNewEventPage = (): any => {
  const [isNavigationBlocked, setIsNavigationBlocked] = useState<boolean>(false)
  const formStateValues = useSelector((state: TReducers) => state.hubEventBasicFormState)
  const formFilesState = useSelector((state: TReducers) => state.hubEventBasicFormFilesState)
  const [initialFormValue, setInitialFormValue] = useState('')
  const filled = fillEvent(formStateValues, formFilesState)
  const [searchParams, setSearchParams] = useSearchParams()
  const validate = searchParams.get('validate')
  if (validate !== undefined && (validate === 'launch' || validate === 'save')) {
    validateAll(validate)
  }
  const [eventForm, setEventForm] = useState(filled)
  const [isFilesSaved, setIsFilesSaved] = useState(false)
  useEffect(() => {
    setInitialFormValue(JSON.stringify(formStateValues))

    return () => {
      store.dispatch(fullResetEvent())
      store.dispatch(resetEventFiles())
    }
  }, [])

  return (
    <>
      <Prompt
        when={isNavigationBlocked}
        message={trans('O formulário contém alterações não salvas. Tem certeza que deseja sair?')}
      />
      <InitialFormContext.Provider value={initialFormValue}>
        {isFilesSaved ? (
          <Loading />
        ) : (
          <FormWrapper
            eventForm={eventForm}
            setIsNavigationBlocked={setIsNavigationBlocked}
            formFilesState={formFilesState}
            formStateValues={formStateValues}
            requireDates={formStateValues.isLaunched ?? false}
            setFilesSaved={setIsFilesSaved}
          ></FormWrapper>
        )}
      </InitialFormContext.Provider>
    </>
  )
}
